import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { ProductCategory, ProductType } from '@snootsvet/shared'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

interface UseListProductsParams {
  q?: string
  category?: ProductCategory
  type?: ProductType[]
  limit?: number
  offset?: number
  active?: boolean
  enabled?: boolean
}

/** Fetches products in the active region, with optional search, filtering, and pagination. */
export function useListProducts(params: UseListProductsParams = {}) {
  const api = useOsApi()
  const { region } = useViewerRegion()
  const { q, category, type, limit, offset, active, enabled } = params

  return useQuery({
    queryKey: ['products', { q, category, type, limit, offset, active, region }],
    enabled,
    queryFn: async () => {
      const response = await api.get('/products', {
        query: { q, category, type, limit, offset, active, region },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    placeholderData: keepPreviousData,
  })
}
